<div class="missing-documents-container">

  <img alt="missing documents" src="/img/missing-documents.png">

  <div [innerHTML]="'Documents.Missing.Title' | translate | safe:'html'"
       class="title"></div>

  <div [innerHTML]="'Documents.Missing.SubTitle' | translate | safe:'html'"
       class="sub-title"></div>

  <div [innerHTML]="'Documents.Missing.Info' | translate | safe:'html'"
       class="info"></div>

  <div class="button-container">
    <button [matDialogClose]="false" class="back">
      <span class="symbol"> &larr; </span>
      {{ 'Documents.Missing.Back' | translate }}
    </button>
    <button [mat-dialog-close]="true" class="next">
      <div [innerHTML]="'Documents.Missing.Next' | translate | safe:'html'"></div>
    </button>
  </div>
</div>
